import { combineReducers } from "redux";
import organisationReducer from "../reducers/organisationReducer";
import userReducer from "../reducers/userReducer";
import inviteReducer from "../reducers/inviteTemplateReducer";
import videoDescriptionReducer from "../reducers/videoDescriptionReducer";
import snackbarReducer from "shared/redux/reducers/SnackbarReducer";

export default combineReducers({
    organisation: organisationReducer,
    user: userReducer,
    invite: inviteReducer,
    video: videoDescriptionReducer,
    snackbar: snackbarReducer
});
